module.exports = __webpack_public_path__ + "static/media/icon_sync_partner.62f43249.svg";